<template>
  <div>
    <el-form
      ref="rowForm"
      :model="rowData"
      :label-width="labelWidth"
      class="demo-ruleForm"
      :rules="rules"
    >
      <el-form-item label="会员名称" prop="nickName">
        <el-input v-model="rowData.nickName" class="width"/>
      </el-form-item>
      <el-form-item label="会员电话" prop="phone" >
        <el-input v-model="rowData.phone" class="width"/>
      </el-form-item>
      <el-form-item label="会员等级" prop="isQingteng" >
        <el-select
          v-model="rowData.isQingteng"
          placeholder="请选择"
          class="width"
        >
          <el-option
            v-for="item in deviceTypeList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </el-form-item>

      <!-- <el-form-item label="会员账号" prop="userCode" >
        <el-input  v-model="rowData.userCode" class="width" :disabled="pageFlag === 2" />
      </el-form-item>
      <el-form-item label="会员密码" prop="password" v-if="pageFlag === 1">
        <el-input v-model="rowData.password" class="width"/>
      </el-form-item> -->

    </el-form>
  </div>
</template>

<script>
import screenMixin from '@/utils/screenMixin'
export default {
  props: {
    rowForm: Object,
    roomList: Array,
    pageFlag: [Number, String]
  },
  mixins: [screenMixin],
  data () {
    const nickNameCheck = (rule, val, callback) => {
      const value = val.trim()
      if (!value) {
        return callback(new Error('不能为空或空格'))
      }

      if (value.length > 20 || value.length < 2) {
        callback(new Error('长度在 2-20 '))
      } else {
        callback()
      }
    }

    const isValidPhoneNumber = (rule, val, callback) => {
      if (/^1[3-9]\d{9}$/.test(val)) {
        callback()
      } else {
        callback(new Error('手机号格式错误'))
      }
    }

    const isPassword = (rule, val, callback) => {
      var patrn = /^(\w){6,20}$/
      console.log(patrn.exec(val))
      if (!patrn.exec(val)) {
        callback(new Error('只能输入6-20个字母、数字、下划线'))
      } else {
        callback()
      }
    }

    return {
      rowData: {
        nickName: '',
        phone: '',
        isQingteng: 0,
        deviceIp: '',
        password: ''
      },
      labelWidth: '110px',
      lineData: [],
      rules: {
        nickName: [{ required: true, message: '请输入', trigger: 'blur' }, {validator: nickNameCheck, trigger: 'blur'}],
        phone: [{ required: true, message: '请输入', trigger: 'blur' }, {validator: isValidPhoneNumber, trigger: 'blur'}],
        userCode: [{ required: true, message: '请选择', trigger: 'blur' }, {validator: nickNameCheck, trigger: 'blur'}],
        password: [{ required: true, message: '请输入', trigger: 'blur' }, {validator: isPassword, trigger: 'blur'}]
      },
      deviceTypeList: [
        {
          label: '青藤',
          value: 1
        },
        {
          label: '普通',
          value: 0
        }
      ]
    }
  },
  watch: {
    screenWidth: function (n, o) {
      if (n <= 1680) {
        this.labelWidth = '80px'
      } else if (n <= 1920) {
        this.labelWidth = '95px'
      } else {
        this.labelWidth = '140px'
      }
    }
  },

  mounted () {
    if (this.rowForm) {
      this.rowData = this.rowForm
    }
  }
}
</script>

<style lang="scss" scoped>
.width{
  width: 85%;
}
</style>
